export default { sha: '5e42ea6f252de5c93ced26e3739c07010cf3680c', buildNumber: 'undefined' }
